{
  "app": {
    "title": "WStudio Reporting Admin",
    "shellTitle": "WSR Product Admin · Console da Plataforma",
    "loading": "Carregando"
  },
  "common": {
    "save": "Salvar",
    "cancel": "Cancelar",
    "delete": "Excluir",
    "remove": "Remover",
    "create": "Criar",
    "edit": "Editar",
    "close": "Fechar",
    "back": "Voltar",
    "next": "Próximo",
    "retry": "Tentar novamente",
    "search": "Pesquisar",
    "filter": "Filtrar",
    "clear": "Limpar",
    "reset": "Redefinir",
    "yes": "Sim",
    "no": "Não",
    "loading": "Carregando",
    "language": "Idioma",
    "actions": "Ações",
    "menu": "Menu",
    "unmapped": "Não mapeado",
    "comingSoon": "Em breve",
    "noProgress": "Sem progresso"
  },
  "help": {
    "ariaLabel": "Ajuda para {{label}}",
    "scope": {
      "platform": "Plataforma",
      "platformDefault": "Por omissão",
      "tenantOverride": "Substituição por inquilino",
      "endpoint": "Endpoint",
      "allJobs": "Todas as tarefas",
      "genesisPacing": "Ritmo da génese",
      "outboundRate": "Débito de saída",
      "attendanceOnly": "Apenas assiduidade"
    }
  },
  "language_switcher": {
    "label": "Idioma",
    "options": {
      "en": "English",
      "es": "Español",
      "fr": "Français",
      "pt": "Português"
    }
  },
  "nav": {
    "home": "Início",
    "tenants": "Inquilinos",
    "globalSettings": "Configurações Globais",
    "ingestionJobs": "Trabalhos de Ingestão",
    "platformSection": "PLATAFORMA",
    "signOut": "Sair",
    "signIn": "Entrar",
    "group": {
      "operations": "Operações",
      "configuration": "Configuração"
    },
    "dashboard": "Painel",
    "queue": "Fila",
    "notifications": "Notificações",
    "engine": "Motor",
    "globalConfig": "Configuração global"
  },
  "shell": {
    "globalStatus": "Global",
    "globalEnabled": "Ativado",
    "globalDisabled": "Desativado",
    "globalUnknown": "–",
    "globalStatusLabel": "Status de ingestão global",
    "scope": "Plataforma — todos os inquilinos",
    "notificationsAriaLabel": "Notificações",
    "role": {
      "productAdmin": "Administrador do produto"
    }
  },
  "page": {
    "dashboard": { "title": "Painel", "subtitle": "Saúde da frota em um relance." },
    "queue": {
      "title": "Fila",
      "subtitle": "Profundidade da fila de ingestão, atividade e próximos trabalhos."
    },
    "notifications": {
      "title": "Notificações",
      "subtitle": "Alertas e notificações do sistema."
    },
    "tenants": { "title": "Inquilinos", "subtitle": "Registro e configuração de inquilinos." },
    "engine": { "title": "Motor", "subtitle": "Configuração do motor e da programação." },
    "globalConfig": {
      "title": "Configuração global do WStudio",
      "subtitle": "Caminhos e parâmetros de endpoints compartilhados por todos os inquilinos."
    }
  },
  "jobType": {
    "USER_SYNC": "Sincronização de usuários",
    "SALES_SYNC": "Sincronização de vendas",
    "ATTENDANCE_SYNC": "Sincronização de presença",
    "REPORT_USER_SYNC_SUMMARY": "Resumo de sincronização de usuários",
    "GHL_FIELD_CHECK": "Verificação de campos GHL",
    "PRODUCT_SYNC": "Sincronização de produtos",
    "SALES_RECONCILE": "Reconciliação de vendas"
  },
  "jobTypeHelp": {
    "SALES_RECONCILE": "Percorre novamente o histórico de vendas para detectar edições posteriores. Uma execução que não atualiza nada é uma execução saudável."
  },
  "notifType": {
    "CREDENTIAL_INVALID": {
      "label": "Credencial inválida",
      "title": "Credencial inválida",
      "body": "A credencial {{integration}} para {{jobType}} é inválida ou expirou."
    },
    "INGESTION_JOB_FAILURE": {
      "label": "Falha no trabalho de ingestão",
      "title": "Falha no trabalho de ingestão",
      "body": "{{jobType}} falhou. Último erro: {{latestError}}"
    },
    "QUEUE_DEPTH_HIGH": {
      "label": "Profundidade da fila alta",
      "title": "Profundidade da fila alta",
      "body": "Há {{pending}} trabalhos pendentes na fila."
    },
    "USER_SYNC_NOT_CONFIGURED": {
      "label": "Sincronização de usuários não configurada",
      "title": "Sincronização de usuários não configurada",
      "body": "{{jobType}} não está configurado: {{reason}}"
    },
    "USER_SYNC_EVENT_WRITE_FAILED": {
      "label": "Falha ao gravar evento de sincronização de usuários",
      "title": "Falha ao gravar evento de sincronização de usuários",
      "body": "Não foi possível gravar o evento de sincronização de usuários: {{reason}}"
    },
    "SALES_SYNC_NOT_CONFIGURED": {
      "label": "Sincronização de vendas não configurada",
      "title": "Sincronização de vendas não configurada",
      "body": "{{jobType}} não está configurado: {{reason}}"
    },
    "ATTENDANCE_SYNC_NOT_CONFIGURED": {
      "label": "Sincronização de presença não configurada",
      "title": "Sincronização de presença não configurada",
      "body": "{{jobType}} não está configurado: {{reason}}"
    },
    "INGESTION_BREAKER_TRIPPED": {
      "label": "Sincronização desativada — falhas repetidas",
      "title": "Sincronização desativada — falhas repetidas",
      "body": "{{jobType}} falhou em {{failureDays}} dias distintos ({{failures}} execuções com falha) em {{windowHours}} h — mais do que os {{maxFailures}} tolerados — por isso o serviço foi desativado. Corrija a causa e reative o serviço. Último erro: {{latestError}}"
    }
  },
  "jobStatus": {
    "PENDING": "Pendente",
    "CLAIMED": "Reivindicado",
    "RUNNING": "Em execução",
    "SUCCEEDED": "Bem-sucedido",
    "FAILED": "Falhou",
    "SKIPPED": "Ignorado"
  },
  "severity": {
    "INFO": "Informação",
    "WARN": "Aviso",
    "ERROR": "Erro"
  },
  "lang": {
    "en": "EN",
    "es": "ES",
    "fr": "FR",
    "pt": "PT"
  },
  "auth": {
    "redirecting": "Redirecionando para login…",
    "returning": "Concluindo login…",
    "noAccessTitle": "Você não tem acesso a este console",
    "noAccessBody": "Sua conta está conectada, mas não recebeu acesso a este console de administração do produto. Entre em contato com o administrador se acreditar que isso é um erro.",
    "productAdminRequired": "Acesso de administrador do produto necessário",
    "productAdminRequiredBody": "Você está conectado, mas sua conta não recebeu acesso a este console de administração do produto.",
    "signedOutTitle": "Você saiu",
    "signedOutBody": "Sua sessão de administrador de plataforma foi encerrada.",
    "signInAgain": "Entrar novamente",
    "errorTitle": "Login não pôde ser concluído",
    "errorBody": "Sua sessão não pôde ser restaurada. Tente entrar novamente.",
    "tryAgain": "Tentar novamente"
  },
  "operator": {
    "menuTitle": "Conta",
    "platformAdminRequired": "Administrador de plataforma necessário",
    "platformAdminRequiredBody": "Você não tem permissão para ver isso. Uma credencial ROLE_PLATFORM_ADMIN é necessária.",
    "role": {
      "SAAS_ADMIN": "Admin de Plataforma",
      "SUPER_ADMIN": "Super Admin"
    }
  },
  "tenants": {
    "title": "Inquilinos",
    "subline": "{{discovered}} descobertos · {{active}} ativos · registro entre inquilinos",
    "searchLabel": "Pesquisar inquilinos",
    "searchPlaceholder": "Pesquisar inquilino ou slug",
    "tableAriaLabel": "Registro de inquilinos",
    "col": {
      "tenant": "Inquilino",
      "status": "Status",
      "wstudio": "wStudio",
      "enabled": "Habilitado",
      "enables": "Habilitações",
      "services": "Serviços",
      "lastSync": "Última sincronização",
      "progress": "Progresso"
    },
    "tabs": {
      "all": "Todos",
      "active": "Ativos",
      "paused": "Pausados",
      "needsAttention": "Requer atenção"
    },
    "enables": {
      "global": "Global",
      "tenant": "Inquilino",
      "on": "Ativado",
      "off": "Desativado",
      "onNotRunning": "Ativado, mas sem execução"
    },
    "detail": {
      "wstudioNotConfigured": "Credenciais do WStudio não configuradas para este inquilino.",
      "servicesTitle": "Serviços",
      "effectiveLabel": "Efetivo: {{state}}"
    },
    "status": {
      "active": "Ativo",
      "inactive": "Inativo",
      "suspended": "Suspenso"
    },
    "wstudio": {
      "configured": "Configurado",
      "notConfigured": "Não configurado"
    },
    "enabled": {
      "true": "Habilitado",
      "false": "Desabilitado"
    },
    "lastSync": {
      "never": "—",
      "justNow": "Agora mesmo",
      "minutesAgo": "{{n}} min atrás",
      "hoursAgo": "{{n}} h atrás",
      "daysAgo": "{{n}} d atrás"
    },
    "backfill": {
      "complete": "✓",
      "neverStarted": "—",
      "through": "até {{date}}",
      "phase": {
        "BACKFILL": "Preenchimento",
        "INCREMENTAL": "Incremental"
      },
      "abbr": {
        "userSync": "US",
        "salesSync": "SS",
        "attendanceSync": "AT",
        "reportSummary": "RS"
      }
    },
    "service": {
      "userSync": "Sincronização de usuários",
      "salesSync": "Sincronização de vendas",
      "attendanceSync": "Sincronização de presença",
      "reportSummary": "Resumo de relatório",
      "on": "Ativado",
      "off": "Desativado"
    },
    "emptyTitle": "Sem inquilinos",
    "emptyBody": "Nenhum inquilino encontrado.",
    "emptySearch": "Nenhum inquilino corresponde à sua pesquisa.",
    "emptyStatus": "Nenhum inquilino desta página corresponde aos filtros selecionados.",
    "loadError": "Não foi possível carregar os inquilinos.",
    "opsLoadError": "Não foi possível carregar os detalhes operacionais.",
    "opsNotProvisioned": "Operações não provisionadas",
    "statusFilter": {
      "label": "Status",
      "all": "Todos",
      "active": "Ativos",
      "suspended": "Suspensos"
    },
    "actionFilter": {
      "label": "Requer atenção",
      "pageOnly": "Filtra os inquilinos carregados nesta página."
    },
    "pagination": {
      "previous": "Anterior",
      "next": "Próximo",
      "pageOf": "Página {{page}} de {{total}}"
    },
    "createButton": "Criar inquilino",
    "create": {
      "title": "Criar inquilino",
      "slugLabel": "Slug",
      "slugHelper": "Letras minúsculas, números, hífens — até 63 caracteres.",
      "slugRequired": "O slug é obrigatório.",
      "slugInvalid": "O slug deve ser um rótulo DNS válido (minúsculas, números, hífens; até 63 caracteres).",
      "nameLabel": "Nome",
      "nameRequired": "O nome é obrigatório.",
      "nameTooLong": "O nome deve ter 200 caracteres ou menos.",
      "signupModeLabel": "Modo de cadastro",
      "submitButton": "Criar",
      "submitting": "Criando…",
      "cancelButton": "Cancelar",
      "errorReservedSlug": "Esse slug está reservado. Escolha outro.",
      "errorDuplicateSlug": "Esse slug já está registrado. Escolha outro.",
      "errorGeneric": "Não foi possível criar o inquilino. Tente novamente.",
      "errorOutcomeUnknown": "Não foi possível confirmar se o inquilino foi criado. A lista de inquilinos foi atualizada — procure “{{slug}}” nela antes de tentar novamente.",
      "longRunningHint": "Criar um inquilino pode levar até 30 segundos.",
      "success": "Inquilino “{{name}}” criado."
    },
    "signupMode": {
      "PUBLIC": "Público",
      "INVITE_ONLY": "Somente por convite",
      "ADMIN_CREATED_ONLY": "Somente criado por admin",
      "DISABLED": "Desativado"
    }
  },
  "queue": {
    "kpi": {
      "pending": "Pendentes",
      "inFlight": "Em andamento",
      "oldestPending": "Pendente mais antigo",
      "failedLast24h": "Falhas (24h)"
    },
    "filters": {
      "tenantLabel": "Inquilino",
      "allTenants": "Todos os inquilinos",
      "pollNote": "Ao vivo — atualiza a cada ~5s",
      "searchLabel": "Filtrar trabalhos",
      "searchPlaceholder": "Inquilino, tipo, status…"
    },
    "col": {
      "id": "ID",
      "tenant": "Inquilino",
      "jobType": "Tipo de trabalho",
      "kind": "Tipo",
      "status": "Status",
      "timing": "Tempo",
      "progress": "Progresso"
    },
    "kind": {
      "GENESIS": "gênese",
      "BACKFILL": "histórico",
      "LEADING_EDGE": "borda atual",
      "INCREMENTAL": "incremental"
    },
    "rowsProcessed": "{{n}} linhas",
    "upcoming": {
      "title": "Próximas",
      "overdueTitle": "Atrasadas",
      "overdueBy": "{{duration}} de atraso",
      "colTenant": "Inquilino",
      "colJob": "Trabalho",
      "colNext": "Próximo",
      "in": "em {{duration}}",
      "dueNow": "pendente agora",
      "empty": "Nada agendado."
    },
    "card": {
      "running": "Em execução {{duration}}",
      "finishedAgo": "Concluído há {{duration}}",
      "scheduledFor": "Agendado {{time}}"
    },
    "tableAriaLabel": "Trabalhos na fila",
    "empty": "Nenhum trabalho ativo.",
    "emptyFiltered": "Nenhum trabalho corresponde aos filtros atuais.",
    "loadError": "Não foi possível carregar a fila."
  },
  "notifications": {
    "filters": {
      "severityLabel": "Gravidade",
      "allSeverities": "Todas as gravidades",
      "tenantLabel": "Inquilino",
      "allTenants": "Todos os inquilinos",
      "platformOption": "Plataforma (*)",
      "tabsAriaLabel": "Filtrar por status"
    },
    "tabs": {
      "all": "Todas",
      "open": "Abertas",
      "acknowledged": "Reconhecidas",
      "resolved": "Resolvidas"
    },
    "status": {
      "OPEN": "Aberta",
      "ACKNOWLEDGED": "Reconhecida",
      "RESOLVED": "Resolvida"
    },
    "meta": {
      "occurrences": "{{n}}× vista",
      "lastSeen": "Vista pela última vez {{time}}"
    },
    "remedy": {
      "credentialInvalid": "Reautentique a credencial {{integration}} no saas-auth e reative {{jobType}}."
    },
    "actions": {
      "acknowledge": "Reconhecer",
      "openTenant": "Abrir inquilino"
    },
    "ackError": "Não foi possível reconhecer esta notificação. Tente novamente.",
    "listAriaLabel": "Notificações",
    "empty": "Nenhuma notificação.",
    "emptyFiltered": "Nenhuma notificação corresponde aos filtros atuais.",
    "loadError": "Não foi possível carregar as notificações.",
    "prevPage": "Página anterior",
    "nextPage": "Próxima página",
    "pageIndicator": "Página {{page}} de {{total}}"
  },
  "dashboard": {
    "kpiRow": {
      "ariaLabel": "KPIs da frota"
    },
    "kpi": {
      "enabledTenants": "Inquilinos habilitados",
      "enabledTenantsValue": "{{enabled}} de {{total}}"
    },
    "depthTable": {
      "title": "Profundidade por tipo de trabalho",
      "ariaLabel": "Profundidade da fila por tipo de trabalho",
      "col": {
        "jobType": "Tipo de trabalho",
        "pending": "Pendente",
        "running": "Em execução",
        "succeeded": "Sucesso",
        "failed": "Falhou"
      },
      "empty": "Ainda não há dados por tipo de trabalho.",
      "loadError": "Não foi possível carregar a profundidade da fila."
    },
    "engineState": {
      "title": "Estado do motor",
      "manageLink": "Gerenciar no Motor",
      "loadError": "Não foi possível carregar o estado do motor."
    },
    "needsAttention": {
      "title": "Requer atenção",
      "viewAll": "Ver todas as notificações",
      "empty": "Nenhuma notificação aberta.",
      "loadError": "Não foi possível carregar as notificações."
    }
  },
  "globalConfig": {
    "formAriaLabel": "Formulário de configuração global do WStudio",
    "loadError": "Não foi possível carregar a configuração global do WStudio.",
    "saveError": "Não foi possível salvar a configuração global do WStudio.",
    "saveSuccess": "Configuração global do WStudio salva.",
    "save": "Salvar configuração",
    "saveAll": "Salvar todas as configurações",
    "saving": "Salvando…",
    "tabs": {
      "ariaLabel": "Seções de configuração global do WStudio",
      "enable": "Ativar",
      "attendance": "Presença",
      "other": "Adicionais"
    },
    "notes": {
      "silentFailure": "Os valores dos endpoints são enviados para o WStudio tal como estão escritos. Um valor incorreto normalmente não devolve dados em vez de um erro — verifique com os testes de simulação após qualquer alteração.",
      "invalidatesVerification": "Guardar uma alteração incrementa a geração da configuração, marcando como obsoletos os resultados dos testes de simulação de todos os inquilinos. Os inquilinos afetados deixam de despachar até que os seus testes de simulação sejam executados novamente."
    },
    "validation": {
      "path": "Insira um caminho começando com /. Uma consulta fixa é permitida."
    },
    "active": {
      "label": "WStudio habilitado",
      "help": "Controla se a configuração compartilhada do WStudio está ativa."
    },
    "groups": {
      "userList": {
        "title": "Lista de usuários",
        "help": "Caminho do endpoint e parâmetros de solicitação para a lista de usuários do WStudio."
      },
      "sales": {
        "title": "Vendas",
        "help": "Caminhos de endpoints e parâmetros para vendas do inquilino e por usuário."
      },
      "report": {
        "title": "Relatório",
        "help": "Caminho do endpoint para o relatório de presença."
      },
      "other": {
        "title": "Configurações adicionais",
        "help": "Chaves globais adicionais retornadas pela wsr-api."
      }
    },
    "fields": {
      "unknownHelp": "Valor global fornecido pela wsr-api.",
      "WStudio_user_listWithFilters": {
        "label": "Caminho da lista de usuários",
        "help": "Caminho após o domínio do inquilino. Uma consulta fixa é permitida.",
        "detail": "Caminho para a lista de utilizadores do WStudio, acrescentado ao domínio de cada inquilino. Fornece todos os membros que a plataforma conhece. Pode incluir uma cadeia de consulta fixa; `filter` e `filters` são acrescentados pelo motor (ver abaixo)."
      },
      "WStudio_user_listWithFilters_max": {
        "label": "Máximo da lista de usuários",
        "help": "Número máximo de usuários solicitados por página.",
        "detail": "Membros obtidos por pedido. O motor pagina até esgotar a lista, pelo que isto controla o tamanho do pedido, não quantos membros são sincronizados."
      },
      "WStudio_user_listWithFilters_offset": {
        "label": "Deslocamento da lista de usuários",
        "help": "Deslocamento inicial para solicitações da lista de usuários.",
        "detail": "Posição inicial da primeira página. Deixe a zero; outro valor ignora membros permanentemente."
      },
      "WStudio_user_listWithFilters_filter": {
        "label": "Termo de pesquisa",
        "help": "Filtro opcional enviado com solicitações da lista de usuários.",
        "detail": "Termo de pesquisa de texto livre do WStudio. Normalmente vazio, e mesmo vazio tem de ser enviado — o endpoint não devolve nada se o parâmetro faltar por completo. Deixe em branco a não ser que queira restringir a lista a nomes correspondentes."
      },
      "WStudio_user_listWithFilters_filters": {
        "label": "Critérios da lista",
        "detail": "Objeto JSON de critérios do WStudio — que membros a lista inclui (ativos, bloqueados, arquivados, funcionários, administradores). Distinto de `filter`, apesar do nome quase igual. Guardado como JSON simples; o motor trata da codificação, por isso não cole um valor já codificado para URL."
      },
      "WStudio_sales_listSales": {
        "label": "Caminho de vendas do inquilino",
        "help": "Caminho após o domínio para vendas de todo o inquilino.",
        "detail": "Caminho para o fluxo de vendas de todo o estúdio — a origem do armazém de vendas e de todos os relatórios de receita. A sua cadeia de consulta inclui `includeDeleted` e um `filter=` vazio obrigatório; remover qualquer um altera o que é devolvido, e omitir `filter=` não devolve nada."
      },
      "WStudio_sales_listForUser": {
        "label": "Caminho de vendas por usuário",
        "help": "Caminho após o domínio para vendas por usuário.",
        "detail": "Caminho para o histórico de compras de um membro. Serve para enriquecer dados por membro, não para relatórios em massa; não é a origem do armazém de vendas."
      },
      "WStudio_sales_listForUser_max": {
        "label": "Máximo de vendas por usuário",
        "help": "Número máximo de vendas solicitadas por usuário.",
        "detail": "Tamanho de página e posição inicial do histórico de um membro. Aplicam-se as mesmas regras: o offset deve ficar a zero."
      },
      "WStudio_sales_listForUser_offset": {
        "label": "Deslocamento de vendas por usuário",
        "help": "Deslocamento inicial para solicitações de vendas por usuário.",
        "detail": "Tamanho de página e posição inicial do histórico de um membro. Aplicam-se as mesmas regras: o offset deve ficar a zero."
      },
      "WStudio_sales_listForUser_forceUpdate": {
        "label": "Forçar atualização",
        "help": "Valor enviado como parâmetro para forçar a atualização de vendas por usuário.",
        "detail": "Quando ativo, o enriquecimento por membro é atualizado em cada sincronização, e não apenas quando a data de expiração mudou. Custa um pedido adicional ao WStudio por membro e execução; deixe desativado a não ser que os dados pareçam desatualizados."
      },
      "WStudio_report_checkin": {
        "label": "Caminho do relatório de presença",
        "help": "Caminho após o domínio para o relatório de presença.",
        "detail": "Caminho para o gerador do relatório de assiduidade. Devolve uma ligação para uma folha de cálculo gerada, que o motor descarrega e analisa — é uma chamada em dois passos, pelo que uma alteração aqui afeta ambos."
      },
      "WStudio_product_listByType": {
        "detail": "Caminho para o catálogo de produtos, consultado uma vez por tipo de produto (abaixo). O catálogo é o que permite classificar uma venda como subscrição, pacote de aulas ou treino pessoal."
      },
      "WStudio_product_listByType_max": {
        "detail": "Tamanho de página e posição inicial do catálogo de produtos. Os catálogos são pequenos; raramente compensa alterar os valores por omissão."
      },
      "WStudio_product_listByType_offset": {
        "detail": "Tamanho de página e posição inicial do catálogo de produtos. Os catálogos são pequenos; raramente compensa alterar os valores por omissão."
      },
      "WStudio_product_types": {
        "detail": "Lista separada por vírgulas dos tipos de produto a obter, p. ex. `byTime`. O catálogo é consultado uma vez por tipo, pelo que acrescentar um tipo acrescenta um pedido por inquilino e execução. Tipos não listados nunca são obtidos, e uma venda que os refira não poderá ser classificada."
      },
      "WStudio_membership_gracePeriodDays": {
        "detail": "Durante quanto tempo após expirar uma subscrição o membro continua a contar como ativo, em período de tolerância, antes de ser tratado como cessado. Ajuste-o ao tempo durante o qual ainda chamaria membro a alguém após um pagamento falhado."
      },
      "WStudio_membership_shortTermThresholdDays": {
        "detail": "Duração abaixo da qual uma compra conta como curto prazo em vez de subscrição. Um passe semanal fica abaixo; uma subscrição mensal não. Isto decide se um comprador é etiquetado como membro ou visitante ocasional."
      },
      "WStudio_membership_renewalDueSoonDays": {
        "detail": "Quantos dias antes da expiração um membro é assinalado como a renovar, para que o marketing atue antes de cessar e não depois."
      },
      "WStudio_membership_tenureEstablishedDays": {
        "detail": "Tempo desde a primeira compra a partir do qual um membro deixa de ser \"novo\". Abaixo é novo; acima, estabelecido."
      },
      "WStudio_membership_tenureLoyalDays": {
        "detail": "Tempo desde a primeira compra a partir do qual um membro conta como fiel. Tem de ser superior ao limiar de estabelecido."
      },
      "WStudio_membership_productFamilyByCategory": {
        "detail": "Associa as suas categorias de produto do WStudio às três famílias que a plataforma compreende — subscrição, aula e treino pessoal — como pares `categoria:família` separados por vírgulas. Uma entrada mal formada é ignorada silenciosamente, pelo que um erro de escrita faz com que essa categoria nunca seja associada; verifique o resultado depois de editar em vez de o presumir."
      },
      "WStudio_membership_valueMidThreshold": {
        "detail": "Limiares de despesa acumulada que separam membros de valor baixo, médio e alto. Os montantes estão na moeda das próprias vendas do membro, sem conversão — um membro com compras em duas moedas fica sem escalão em vez de receber um total enganador. Ambos têm de estar definidos ou não é produzido qualquer escalão."
      },
      "WStudio_membership_valueHighThreshold": {
        "detail": "Limiares de despesa acumulada que separam membros de valor baixo, médio e alto. Os montantes estão na moeda das próprias vendas do membro, sem conversão — um membro com compras em duas moedas fica sem escalão em vez de receber um total enganador. Ambos têm de estar definidos ou não é produzido qualquer escalão."
      },
      "WStudio_genesis_syncReadyCoverageDays": {
        "detail": "Quanto histórico de assiduidade tem de estar carregado antes de um inquilino começar a sincronizar com o GoHighLevel. É a condição que decide quando um inquilino recém-ativado entra em produção, e até ser cumprida nada chega ao CRM — o que está correto, já que sinais de envolvimento calculados sobre histórico parcial estariam errados. Baixe-o para entrar mais cedo com menos histórico; aumente-o para ser mais conservador."
      },
      "GhlFieldMappings_CONTACT_PREFIX": {
        "detail": "Prefixo que identifica quais definições associam campos de membro do WStudio a campos de contacto do GoHighLevel. É estrutural, não um valor a afinar; alterá-lo deixa órfãs todas as associações existentes."
      }
    }
  },
  "global": {
    "title": "Configurações Globais",
    "subtitle": "Controles em toda a plataforma. As alterações se aplicam a todos os inquilinos.",
    "enableSection": "Ingestão global",
    "enableDescription": "Quando desativado, o agendador não enfileira nada para nenhum inquilino. A descoberta ainda é executada enquanto estiver desativado.",
    "enableLabel": "Ativar ingestão global",
    "toggleEnabled": "Ativado",
    "toggleDisabled": "Desativado",
    "toggleUnknown": "Desconhecido",
    "toggleSuccessOn": "Ingestão global ativada.",
    "toggleSuccessOff": "Ingestão global desativada.",
    "toggleError": "Não foi possível atualizar a configuração global. Tente novamente.",
    "discoverySection": "Descoberta de registro",
    "discoveryDescription": "Executa a varredura de reconciliação saas-auth sob demanda. Novos inquilinos se materializam inativos e desabilitados.",
    "discoveryButton": "Executar descoberta agora",
    "discoveryRunning": "Executando descoberta…",
    "discoveryError": "A descoberta falhou. Tente novamente.",
    "discoveryResultTitle": "Descoberta concluída",
    "discoveryResultSeen": "Vistos",
    "discoveryResultCreated": "Criados",
    "discoveryResultStatusUpdated": "Status atualizado",
    "discoveryResultLeaversFlagged": "Saídas sinalizadas",
    "statsSection": "Contagens de frota",
    "statTotal": "Total de inquilinos",
    "statActive": "Ativos",
    "statActiveNote": "(status = ativo)",
    "statWstudio": "wStudio configurado",
    "loadError": "Não foi possível carregar as contagens de frota."
  },
  "engine": {
    "loadError": "Não foi possível carregar a configuração do motor.",
    "formAriaLabel": "Formulário de configuração do motor",
    "restartRequired": "Requer reinicialização",
    "unit": {
      "seconds": "segundos",
      "count": "contagem"
    },
    "validation": {
      "secondsMin1": "Deve ser um inteiro ≥ 1.",
      "countMin0": "Deve ser um inteiro ≥ 0.",
      "countMin1": "Deve ser um inteiro ≥ 1.",
      "isolationInvalid": "Deve ser um dos 5 níveis de isolamento suportados.",
      "invariant": "heartbeatIntervalSeconds deve ser menor que leaseTtlSeconds, que deve ser menor que maxExecutionTimeSeconds.",
      "invariantHint": "Faz parte do invariante heartbeat/lease/max-execution."
    },
    "save": {
      "success": "Configuração salva.",
      "error": "Não foi possível salvar a configuração. Tente novamente.",
      "changedCount": "{{count}} alterados",
      "noChanges": "Sem alterações",
      "revert": "Reverter",
      "save": "Salvar",
      "saveAll": "Salvar todas as configurações",
      "saving": "Salvando…"
    },
    "tabs": {
      "ariaLabel": "Seções de configuração do motor"
    },
    "group": {
      "cadence": "Cadências",
      "retention": "Retenção",
      "tuning": "Ajustes"
    },
    "flags": {
      "title": "Iniciar / parar",
      "globalReadOnly": "Global (somente leitura — ver Inquilinos)",
      "toggleError": "Não foi possível atualizar. Tente novamente.",
      "engineEnabled": "Motor",
      "engineEnabledDescription": "O ciclo dispatcher/claimer/heartbeat/reaper que executa os trabalhos.",
      "discoveryEnabled": "Descoberta",
      "discoveryEnabledDescription": "A varredura de reconciliação do registro de inquilinos do saas-auth.",
      "pruneEnabled": "Poda",
      "pruneEnabledDescription": "Limpeza de retenção de trabalhos terminais e eventos.",
      "orphanSweepEnabled": "Varredura de órfãos",
      "orphanSweepEnabledDescription": "Elimina ficheiros temporários residuais do processo de assiduidade, que descarrega uma folha de cálculo gerada para disco e normalmente a apaga de imediato. Esta varredura é a salvaguarda para um processo terminado a meio do descarregamento. Não afeta tarefas nem dados."
    },
    "fields": {
      "engineEnabled": {
        "detail": "Interruptor principal do ciclo de ingestão: despachante, reclamador, pulsação e recuperador. Desligá-lo é uma pausa controlada — as tarefas em curso terminam, nada novo é enfileirado ou reclamado e nenhum dado se perde. Use-o para silenciar a plataforma durante manutenção, em vez de desativar inquilinos um a um."
      },
      "discoveryEnabled": {
        "detail": "Varredura que reconcilia a lista de inquilinos com o saas-auth, para que os adicionados ou removidos lá apareçam aqui sem registo manual. Desligá-lo congela a lista; os inquilinos existentes continuam a sincronizar normalmente."
      },
      "pruneEnabled": {
        "detail": "Manutenção que elimina tarefas terminadas e eventos de auditoria mais antigos do que as janelas de retenção. Desligá-lo mantém o histórico indefinidamente e as tabelas crescem sem limite."
      },
      "orphanSweepEnabled": {
        "detail": "Elimina ficheiros temporários residuais do processo de assiduidade, que descarrega uma folha de cálculo gerada para disco e normalmente a apaga de imediato. Esta varredura é a salvaguarda para um processo terminado a meio do descarregamento. Não afeta tarefas nem dados."
      },
      "dispatcherIntervalSeconds": {
        "detail": "Com que frequência o motor verifica que tarefas estão devidas e as enfileira. É um limite mínimo para tudo o resto: uma tarefa agendada a cada minuto só arranca quando o despachante corre. Com 900s (15m), uma janela de assiduidade avança no máximo quatro vezes por hora; com 60s, até uma vez por minuto. Baixá-lo é barato — a verificação é uma única consulta."
      },
      "claimerIntervalSeconds": {
        "detail": "Com que frequência os trabalhadores procuram trabalho enfileirado. É um sondar de linhas já criadas: controla a latência de recolha, não o volume de trabalho. Os 5s por omissão raramente compensam alterar."
      },
      "heartbeatIntervalSeconds": {
        "detail": "Com que frequência uma tarefa em curso sinaliza que continua viva, estendendo o seu arrendamento. Deve ficar bem abaixo do TTL do arrendamento, ou uma tarefa longa e saudável — um percurso de génese ou uma janela grande de assiduidade — será reclamada como se tivesse falhado."
      },
      "reaperIntervalSeconds": {
        "detail": "Com que frequência o motor procura tarefas cujo arrendamento expirou ou que excederam o tempo máximo de execução, devolvendo-as à fila. É o que recupera trabalho após uma falha ou uma implantação que reiniciou a aplicação a meio."
      },
      "terminalCleanupIntervalSeconds": {
        "detail": "Com que frequência as tarefas terminadas para além da retenção são eliminadas. Pura manutenção; nunca toca em trabalho em curso ou pendente."
      },
      "discoveryIntervalSeconds": {
        "detail": "Com que frequência a lista de inquilinos é reconciliada com o saas-auth. De hora a hora é suficiente — um inquilino novo aparece dentro de um intervalo."
      },
      "pruneIntervalSeconds": {
        "detail": "Com que frequência corre a limpeza por retenção. Pouco frequente é adequado: é uma eliminação em massa, melhor executá-la raramente do que constantemente."
      },
      "orphanSweepIntervalSeconds": {
        "detail": "Com que frequência se procuram ficheiros temporários residuais. Só são removidos os mais antigos do que a idade de varredura, pelo que pode correr raramente sem risco."
      },
      "terminalRetentionSeconds": {
        "detail": "Durante quanto tempo as tarefas terminadas são mantidas antes da purga. É o seu histórico: com 14 dias pode investigar uma falha da semana passada, mas não do mês passado. Aumentá-lo custa tamanho de tabela, não desempenho."
      },
      "eventRetentionSeconds": {
        "detail": "Durante quanto tempo os eventos de auditoria e atividade são mantidos. Mais longo do que a retenção de tarefas por desenho — os eventos registam o que mudou e quem mudou, algo útil muito depois de a tarefa que os gerou deixar de importar."
      },
      "orphanSweepAgeSeconds": {
        "detail": "Que idade um ficheiro temporário deve ter antes de ser removido. Tem de exceder o descarregamento de assiduidade mais lento realista, ou a varredura poderia apagar um ficheiro ainda em uso. As 6 horas por omissão são deliberadamente generosas."
      },
      "defaultFrequencySeconds": {
        "detail": "Intervalo de repetição usado por tipos de tarefa que não definem agenda própria. Os tipos com agenda real — sincronizações diárias, varredura de reconciliação, esperas de recuperação — ignoram-no por completo."
      },
      "leaseTtlSeconds": {
        "detail": "Durante quanto tempo uma tarefa reclamada é considerada viva sem pulsação antes de o recuperador a poder retomar. Defina-o em vários múltiplos do intervalo de pulsação; demasiado apertado e tarefas longas e saudáveis são retomadas a meio, repetindo trabalho."
      },
      "maxExecutionTimeSeconds": {
        "detail": "Teto absoluto de uma execução, independentemente das pulsações. Uma tarefa que o exceda é tratada como bloqueada e terminada, em vez de repetida indefinidamente. Tem de exceder a sua execução legítima mais lenta — uma janela grande de assiduidade ou um percurso longo de génese."
      },
      "retryBackoffBaseSeconds": {
        "detail": "Espera inicial antes de repetir uma tarefa falhada. Cada falha seguinte espera mais, até ao teto abaixo, para que uma indisponibilidade passageira não se torne um ciclo apertado de tentativas contra um sistema já em dificuldades."
      },
      "retryBackoffCapSeconds": {
        "detail": "Espera máxima a que a repetição pode crescer. Limita quanto os dados podem envelhecer durante uma falha prolongada: com 1 hora, um inquilino tenta pelo menos de hora a hora, por mais longa que seja a indisponibilidade."
      },
      "ratePerTenantPeriodSeconds": {
        "detail": "Janela temporal sobre a qual são contadas as permissões de pedido por inquilino. Com as permissões abaixo forma a regra \"no máximo N pedidos por inquilino e período\" — o controlo principal sobre a pressão exercida sobre cada estúdio WStudio."
      },
      "rateGlobalPeriodSeconds": {
        "detail": "Janela do teto de pedidos de toda a plataforma. Só se aplica quando as permissões globais são maiores do que zero. Requer reinício."
      },
      "maxAttempts": {
        "detail": "Quantas vezes uma tarefa falhada é repetida antes de ser marcada como falhada em definitivo. Distinto dos resgates: as tentativas contam a tarefa falhar, os resgates contam o trabalhador morrer."
      },
      "maxRescues": {
        "detail": "Quantas vezes uma tarefa pode ser recuperada após a morte do seu trabalhador — uma falha ou uma implantação — antes de ser tratada como tóxica e falhada. Contado à parte das tentativas, para não imputar a uma tarefa falhas que não causou."
      },
      "batchClaimSize": {
        "detail": "Quantas tarefas enfileiradas um trabalhador reclama numa única ida à base de dados. Lotes maiores reduzem a sobrecarga quando a fila é profunda; lotes menores distribuem melhor. Raramente compensa alterar."
      },
      "perTenantInFlightCap": {
        "detail": "Número máximo de tarefas que podem correr em simultâneo para um mesmo inquilino. Com 1, as suas sincronizações de vendas, assiduidade, produtos e utilizadores correm estritamente em série — a principal razão para o carregamento do histórico parecer lento. Subir para 3 permite que a recuperação de assiduidade avance em paralelo, sem que um inquilino ocupe todo o conjunto de trabalhadores."
      },
      "maxConcurrent": {
        "detail": "Número total de tarefas a correr em simultâneo em todos os inquilinos. É o teto da plataforma; o limite por inquilino reparte-o com equidade. Com 5 simultâneas e um limite de 3 por inquilino, um inquilino ocupado nunca toma mais de três das cinco vagas. Requer reinício."
      },
      "failureAlertThreshold": {
        "detail": "Quantas falhas consecutivas da mesma tarefa para o mesmo inquilino são necessárias antes de ser gerada uma notificação. Com 3, as duas primeiras falhas são silenciosas. Defina 1 para ser avisado de cada falha — útil ao integrar inquilinos ou diagnosticar uma ligação nova."
      },
      "failureBreakerMaxFailures": {
        "detail": "Quantos dias distintos (horário do estúdio) uma tarefa pode falhar para um inquilino — contados desde a última execução bem-sucedida ou reativação, e apenas dentro da janela do disjuntor — antes de o serviço desse inquilino ser desativado. 0 desativa-o no primeiro dia com falha. Distinto do limiar de alerta de falhas acima, que apenas gera uma notificação."
      },
      "failureBreakerWindowHours": {
        "detail": "Só contam para o disjuntor as falhas dentro destas últimas horas. 0 desliga o disjuntor: as falhas continuam a gerar alertas, mas o serviço nunca é desativado."
      },
      "ratePerTenantPermits": {
        "detail": "Quantos pedidos ao WStudio são permitidos por inquilino em cada período. É o botão de cortesia — limita a pressão sobre um estúdio concreto, independentemente de quantas tarefas estejam a correr. Baixe-o se o sistema remoto se queixar; suba-o com prudência."
      },
      "rateGlobalPermits": {
        "detail": "Teto de toda a plataforma, somando inquilinos. Zero desativa-o, deixando apenas o limite por inquilino — a configuração habitual, já que os estúdios são sistemas separados e o tráfego de um inquilino não onera o de outro. Requer reinício."
      },
      "skipLockedClaim": {
        "detail": "Permite aos trabalhadores saltar linhas já bloqueadas por outro em vez de esperar por elas. Mantenha-o ativo: desativado, os trabalhadores fazem fila pelas mesmas linhas e o desempenho cai bastante. Desative-o apenas se a base de dados não suportar a funcionalidade."
      },
      "isolation": {
        "detail": "Nível de isolamento de transação ao reclamar tarefas. `READ_COMMITTED` é a escolha correta para esta fila e não deve ser alterado sem um motivo concreto — níveis mais estritos acrescentam contenção sem benefício aqui. Requer reinício."
      }
    },
    "emphasis": {
      "dispatcherInterval": "É um limite mínimo para tudo o resto: uma tarefa agendada a cada minuto só arranca quando o despachante corre.",
      "inFlightCap": "Com 1, as suas sincronizações de vendas, assiduidade, produtos e utilizadores correm estritamente em série — a principal razão para o carregamento do histórico parecer lento.",
      "failureBreakerMaxFailures": "Dias distintos (horário do estúdio) com uma execução com falha, desde a última execução bem-sucedida ou reativação, antes de o serviço ser desativado. 0 = desativar no primeiro dia com falha.",
      "failureBreakerWindowHours": "Só contam as falhas dentro desta quantidade de horas. 0 = disjuntor desligado (apenas alertas)."
    },
    "knob": {
      "dispatcherIntervalSeconds": "Intervalo do dispatcher",
      "claimerIntervalSeconds": "Intervalo do claimer",
      "heartbeatIntervalSeconds": "Intervalo do heartbeat",
      "reaperIntervalSeconds": "Intervalo do reaper",
      "terminalCleanupIntervalSeconds": "Intervalo de limpeza terminal",
      "discoveryIntervalSeconds": "Intervalo de descoberta",
      "pruneIntervalSeconds": "Intervalo de poda",
      "orphanSweepIntervalSeconds": "Intervalo de varredura de órfãos",
      "terminalRetentionSeconds": "Retenção terminal",
      "eventRetentionSeconds": "Retenção de eventos",
      "orphanSweepAgeSeconds": "Idade de varredura de órfãos",
      "defaultFrequencySeconds": "Frequência padrão",
      "leaseTtlSeconds": "TTL de concessão",
      "maxExecutionTimeSeconds": "Tempo máximo de execução",
      "retryBackoffBaseSeconds": "Base de repetição com recuo",
      "retryBackoffCapSeconds": "Limite de repetição com recuo",
      "ratePerTenantPeriodSeconds": "Período de limite de taxa (por inquilino)",
      "rateGlobalPeriodSeconds": "Período de limite de taxa (global)",
      "maxAttempts": "Máximo de tentativas",
      "maxRescues": "Máximo de resgates",
      "batchClaimSize": "Tamanho do lote de reivindicação",
      "perTenantInFlightCap": "Limite em andamento (por inquilino)",
      "maxConcurrent": "Máximo concorrente",
      "failureAlertThreshold": "Limite de alerta de falha",
      "failureBreakerMaxFailures": "Dias de falha tolerados",
      "failureBreakerWindowHours": "Janela do disjuntor (horas)",
      "ratePerTenantPermits": "Permissões de limite de taxa (por inquilino)",
      "rateGlobalPermits": "Permissões de limite de taxa (global)",
      "skipLockedClaim": "Ignorar bloqueados ao reivindicar",
      "isolation": "Isolamento de transação"
    }
  },
  "jobs": {
    "tableAriaLabel": "Trabalhos de ingestão",
    "empty": "Nenhum trabalho registrado.",
    "prevPage": "Página anterior",
    "nextPage": "Próxima página",
    "pageIndicator": "Página {{page}} de {{total}}",
    "col": {
      "job": "Trabalho",
      "status": "Status",
      "type": "Tipo",
      "tenant": "Inquilino",
      "started": "Iniciado",
      "duration": "Duração",
      "records": "Registros",
      "actions": "Ações"
    },
    "status": {
      "queued": "Na fila",
      "running": "Em execução",
      "success": "Sucesso",
      "failed": "Falhou",
      "skipped": "Ignorado"
    },
    "chip": {
      "statusAriaLabel": "Status: {{label}}"
    },
    "actions": {
      "cancel": "Cancelar",
      "cancelNotSupported": "Cancelamento ainda não disponível",
      "cancelAriaLabel": "Cancelar trabalho {{id}}"
    }
  },
  "ingestionJobs": {
    "title": "Trabalhos de Ingestão",
    "filtersAriaLabel": "Filtros de trabalho",
    "filterStatus": "Status",
    "filterType": "Tipo",
    "filterTenant": "Inquilino",
    "allStatuses": "Todos os status",
    "allTypes": "Todos os tipos",
    "allTenants": "Todos os inquilinos",
    "typeUserSync": "Sincronização de usuários",
    "typeSalesSync": "Sincronização de vendas",
    "typeAttendanceSync": "Sincronização de presença",
    "typeReportSummary": "Resumo de sincronização",
    "totalCount": "{{total}} trabalhos",
    "tableAriaLabel": "Trabalhos de ingestão entre inquilinos",
    "loadError": "Não foi possível carregar os trabalhos de ingestão."
  },
  "tenant": {
    "tab": {
      "overview": "Visão geral",
      "members": "Equipe",
      "invitations": "Convites",
      "ingestion": "Ingestão",
      "history": "Histórico de sincronização",
      "wstudio": "WStudio Config",
      "contacts": "Mapeamento de contactos",
      "advanced": "Avançado",
      "settings": "Configurações"
    }
  },
  "problems": {
    "jobFailures": "{{job}} — {{code}}, {{count}}× em 24 h, há {{ago}}",
    "ghlWriteFailures": "{{count}} contatos não puderam ser gravados no GoHighLevel na última execução.",
    "noData": "{{job}} — nenhum registro na última execução; vale a pena verificar.",
    "verification": "{{job}} — a verificação não passa; execute o teste novamente",
    "generic": "{{job}} — requer atenção"
  },
  "runNow": {
    "button": "Executar agora",
    "enqueued": "{{service}} foi colocado na fila. Aparecerá na Fila em alguns segundos.",
    "alreadyRunning": "{{service}} já está em execução.",
    "blockedTitle": "{{service}} não pode ser executado:",
    "error": "Não foi possível iniciar {{service}}.",
    "queueLink": "Abrir a Fila",
    "blocked": {
      "GLOBAL_DISABLED": "A ingestão está desativada globalmente.",
      "TENANT_DISABLED": "Este inquilino está desativado.",
      "SERVICE_DISABLED": "Este serviço está desativado.",
      "NOT_VERIFIED": "Execute primeiro os testes de simulação.",
      "NOT_SYNC_READY": "Aguardando o histórico terminar de carregar.",
      "NOT_CONFIGURED": "As credenciais do WStudio não estão configuradas para este inquilino.",
      "unknown": "Este serviço não pode ser executado agora."
    }
  },
  "tenantDetail": {
    "loadError": "Não foi possível carregar o inquilino. Tente novamente.",
    "notFound": "Inquilino não encontrado",
    "notFoundBody": "O inquilino '{{slug}}' não pôde ser encontrado.",
    "backToRoster": "Voltar aos inquilinos",
    "opsLoadError": "Não foi possível carregar a configuração operacional.",
    "tabs": {
      "ariaLabel": "Seções de detalhes do inquilino"
    },
    "overview": {
      "disabledTitle": "Desativado",
      "disabledGlobal": "A ingestão está desativada em toda a plataforma",
      "disabledTenant": "Este inquilino está desativado",
      "disabledHint": "Altere-os na aba Ingestão.",
      "problemsTitle": "Problemas",
      "problemsNone": "Sem problemas — falhas e verificações desatualizadas aparecem aqui.",
      "problemStale": "{{job}} — a verificação está desatualizada, execute o teste novamente",
      "problemFailed": "{{job}} — a verificação falhou"
    },
    "settings": {
      "title": "Configurações WStudio do tenant",
      "formAriaLabel": "Formulário de configurações WStudio do tenant",
      "loadError": "Não foi possível carregar as configurações do WStudio.",
      "save": "Salvar configurações do WStudio",
      "saving": "Salvando…",
      "saveSuccess": "Configurações do WStudio salvas.",
      "saveSuccessReverify": "A configuração mudou — execute novamente os quatro testes de simulação para verificar este inquilino.",
      "saveError": "Não foi possível salvar as configurações do WStudio.",
      "domain": { "label": "Domínio", "help": "URL base obrigatória do tenant WStudio." },
      "token": {
        "label": "Token da API WStudio",
        "set": "Definido · {{suffix}}",
        "notSet": "Não definido",
        "replace": "Substituir",
        "replacement": "Novo token",
        "help": "Somente gravação. Em branco preserva o token salvo."
      },
      "studioId": { "label": "ID do estúdio", "help": "Valor do cabeçalho Studioid do WStudio." },
      "reportUserId": {
        "label": "ID do usuário de relatório",
        "help": "ID usado para gerar relatórios de presença."
      },
      "contacts": {
        "title": "Mapeamentos de campos de contato",
        "help": "Mapeie chaves contact.* para IDs de campo GHL.",
        "key": "Chave de contato",
        "value": "ID do campo GHL",
        "add": "Adicionar mapeamento",
        "remove": "Remover",
        "catalogTitle": "Mapeamentos padrão",
        "catalogHelp": "Gerenciados globalmente e aplicados a todos os inquilinos. O ID do campo do GoHighLevel é resolvido automaticamente.",
        "addedTitle": "Mapeamentos adicionais",
        "addedHelp": "Escolha um atributo de usuário do WStudio. O ID do campo do GoHighLevel é detectado ao salvar.",
        "col": {
          "key": "Chave de contato",
          "attribute": "Atributo do WStudio",
          "fieldId": "ID do campo do GoHighLevel",
          "status": "Status"
        },
        "attributeLabel": "Atributo de usuário do WStudio",
        "fieldKeyLabel": "Chave do campo do GoHighLevel",
        "status": {
          "resolved": "Resolvido",
          "legacy": "Resolvido por ID",
          "notFound": "Não encontrado no GoHighLevel",
          "unknownAttribute": "Atributo desconhecido",
          "retired": "Descontinuado",
          "retiredHelp": "Mapeamentos para campos principais não são mais suportados. Este mapeamento é ignorado — remova-o."
        },
        "unresolvedWarning": "Não foi possível resolver um ou mais mapeamentos obrigatórios. Crie o campo personalizado correspondente no GoHighLevel e execute novamente os testes de simulação.",
        "attributesUnavailable": "A lista de atributos do WStudio está indisponível, portanto não é possível adicionar novos mapeamentos agora."
      },
      "advanced": {
        "title": "Avançado — substituir configuração global",
        "override": "Substituir",
        "overriding": "Substituindo",
        "default": "Padrão",
        "revert": "Reverter ao padrão",
        "derived": "Valor derivado",
        "defaultValue": "padrão: {{value}}",
        "fullUrl": "URL completa substituta",
        "urlHelp": "Uma URL substituta troca completamente o domínio e o caminho global."
      },
      "validation": {
        "domain": "O domínio é obrigatório.",
        "contact": "Informe uma chave contact.<campo> e um ID para cada mapeamento.",
        "duplicateContact": "As chaves de contato devem ser únicas.",
        "attributeRequired": "Escolha um atributo de usuário do WStudio para cada mapeamento.",
        "fullUrl": "Informe uma URL http(s) completa.",
        "nonNegativeInt": "Insira um número inteiro maior ou igual a 0.",
        "nonNegativeNumber": "Insira um valor maior ou igual a 0.",
        "valueThresholdOrder": "O limite de valor médio deve ser menor ou igual ao de valor alto.",
        "tenureOrder": "O limite de tempo estabelecido deve ser menor ou igual ao de tempo fiel."
      },
      "membership": {
        "title": "Assinatura e classificação",
        "help": "Estas configurações são lidas em conjunto para classificar membros para marketing.",
        "valueHelp": "Ambos os limites devem estar definidos para que a classificação por valor seja executada. Deixá-los em branco é uma escolha válida — nenhuma classificação por valor é produzida.",
        "valuePartial": "Apenas um limite está definido, portanto a classificação por valor permanece desativada."
      },
      "fields": {
        "WStudio_user_listWithFilters": "URL da lista de usuários",
        "WStudio_user_listWithFilters_max": "Máximo de usuários",
        "WStudio_user_listWithFilters_offset": "Deslocamento de usuários",
        "WStudio_user_listWithFilters_filter": "Filtro de usuários",
        "WStudio_sales_listSales": "URL de vendas do tenant",
        "WStudio_sales_listForUser": "URL de vendas por usuário",
        "WStudio_sales_listForUser_max": "Máximo de vendas por usuário",
        "WStudio_sales_listForUser_offset": "Deslocamento de vendas por usuário",
        "WStudio_sales_listForUser_forceUpdate": "Forçar atualização",
        "WStudio_report_checkin": "URL do relatório de presença",
        "WStudio_product_listByType": "URL do catálogo de produtos",
        "WStudio_product_listByType_max": "Máximo do catálogo de produtos",
        "WStudio_product_listByType_offset": "Deslocamento do catálogo de produtos",
        "WStudio_product_types": "Tipos de produto a sincronizar",
        "WStudio_membership_gracePeriodDays": "Período de carência (dias)",
        "WStudio_membership_shortTermThresholdDays": "Limite de curto prazo (dias)",
        "WStudio_membership_renewalDueSoonDays": "Renovação próxima (dias)",
        "WStudio_membership_tenureEstablishedDays": "Tempo estabelecido (dias)",
        "WStudio_membership_tenureLoyalDays": "Tempo fiel (dias)",
        "WStudio_membership_valueMidThreshold": "Limite de valor médio",
        "WStudio_membership_valueHighThreshold": "Limite de valor alto",
        "WStudio_genesis_syncReadyCoverageDays": "Cobertura de presença necessária antes da sincronização (dias)"
      }
    },
    "verification": {
      "allVerified": "WStudio verificado",
      "notVerified": "WStudio não configurado / não verificado",
      "prompt": "Execute os quatro testes de simulação para verificar este inquilino.",
      "verified": "Verificado",
      "failed": "Falhou",
      "notRun": "Não executado",
      "stale": "Desatualizado — execute novamente"
    },
    "header": {
      "dispatchState": "Estado de despacho",
      "dispatchRunning": "Sincronizações em andamento",
      "dispatchUnknown": "Estado global desconhecido",
      "blockedGlobal": "Bloqueado — global desativado",
      "blockedTenant": "Bloqueado — inquilino desativado",
      "blockedServices": "Bloqueado — nenhum serviço habilitado",
      "lastSync": "Última sincronização",
      "statusLabel": "Status do inquilino: {{status}}",
      "leftRosterChip": "Saiu do registro",
      "leftRosterAriaLabel": "Este inquilino saiu do registro saas-auth",
      "leftRosterBody": "Este inquilino saiu do registro saas-auth. Foi sinalizado mas não excluído — os dados existentes são preservados."
    },
    "actions": {
      "title": "Ações do inquilino",
      "tenantEnabled": "Inquilino habilitado",
      "enabledLabel": "Inquilino habilitado",
      "disabledLabel": "Inquilino desabilitado",
      "tenantEnabledHelper": "Quando desativado, este inquilino é completamente ignorado — sem sincronizações ou relatórios.",
      "enableSuccess": "Inquilino habilitado.",
      "disableSuccess": "Inquilino desabilitado.",
      "enableError": "Não foi possível atualizar o status do inquilino. Tente novamente.",
      "confirmEnableTitle": "Habilitar inquilino?",
      "confirmEnableBody": "Isso permitirá que as sincronizações sejam executadas para este inquilino quando os interruptores global e de serviço também estiverem ativados.",
      "confirmDisableTitle": "Desabilitar inquilino?",
      "confirmDisableBody": "Isso impedirá todas as sincronizações e relatórios para este inquilino.",
      "statusActionsTitle": "Status do inquilino",
      "markActive": "Marcar como ativo",
      "suspendTenant": "Suspender inquilino",
      "statusWriteUnavailable": "O gerenciamento de status ainda não está disponível nesta console. Use o saas-admin para alterar o status.",
      "statusWriteHint": "O status é gerenciado via saas-admin."
    },
    "confirm": {
      "confirmButton": "Confirmar",
      "cancelButton": "Cancelar"
    },
    "gate": {
      "title": "Interruptores de habilitação",
      "gateRule": "Regra do portão:",
      "explainer": "Um trabalho é executado somente quando global, inquilino e serviço estão TODOS ativos.",
      "globalLevel": "Global",
      "globalReadOnly": "Somente leitura aqui.",
      "globalLink": "Gerenciar em Configurações Globais",
      "tenantLevel": "Inquilino",
      "tenantHint": "Gerenciado em Ações do inquilino acima.",
      "serviceLevel": "Serviços",
      "gateOn": "Ativado",
      "gateOff": "Desativado",
      "gateUnknown": "Desconhecido"
    },
    "services": {
      "enableSuccess": "{{service}} habilitado.",
      "disableSuccess": "{{service}} desabilitado.",
      "enableError": "Não foi possível atualizar {{service}}."
    },
    "config": {
      "title": "Configuração",
      "formAriaLabel": "Formulário de configuração do inquilino",
      "saveButton": "Salvar configuração",
      "saving": "Salvando…",
      "resetButton": "Redefinir",
      "unsavedChanges": "Alterações não salvas",
      "saveSuccess": "Configuração salva.",
      "saveError": "Não foi possível salvar a configuração. Tente novamente.",
      "validationError": "Validação falhou. Verifique sua entrada e tente novamente.",
      "fieldRequired": "Este campo é obrigatório.",
      "freqMin1": "A frequência deve ser um inteiro ≥ 1.",
      "invalidTime": "Deve estar no formato HH:mm (ex. 00:30).",
      "invalidSendTimes": "Cada horário deve estar no formato HH:mm, separados por vírgulas.",
      "invalidDate": "Deve ser uma data válida (AAAA-MM-DD).",
      "cooldownMin1": "O intervalo deve ser um inteiro ≥ 1.",
      "userSyncFrequency": "Frequência de sincronização de usuários (horas)",
      "userSyncFrequencyHelper": "Com que frequência a sincronização WStudio→GHL é executada. Mínimo 1.",
      "dailySyncTime": "Horário de sincronização diária (HH:mm)",
      "dailySyncTimeHelper": "Quando a extração diária do dia anterior é executada.",
      "userSyncSendTimes": "Horários de envio do resumo",
      "userSyncSendTimesPlaceholder": "ex. 09:00,17:00",
      "userSyncSendTimesHelper": "Horários HH:mm separados por vírgulas para o e-mail de resumo. Vazio = sem relatório agendado.",
      "backfillStartDate": "Data de início do preenchimento",
      "backfillStartDateHelper": "Data de origem para o preenchimento de vendas/presença (AAAA-MM-DD).",
      "backfillCooldown": "Intervalo de preenchimento (minutos)",
      "backfillCooldownHelper": "Descanso entre blocos semanais de preenchimento em minutos."
    },
    "dryRun": {
      "title": "Testes de simulação",
      "subtitle": "Valide antes de habilitar — nenhum dado é gravado.",
      "salesTitle": "Simulação de vendas",
      "attendanceTitle": "Simulação de presença",
      "userTitle": "Simulação de usuários",
      "ghlFieldsTitle": "Verificação de campos do GHL",
      "from": "De",
      "to": "Até",
      "run": "Executar teste",
      "running": "Executando…",
      "runError": "A solicitação de simulação falhou. Tente novamente.",
      "success": "Sucesso",
      "failure": "Falhou",
      "notConfigured": "Não configurado",
      "warnings": "Avisos",
      "sampleData": "Dados de amostra",
      "sampleRows": "{{n}} linhas",
      "errorLabel": "Erro:",
      "unknownError": "Erro desconhecido",
      "writeNothing": "Apenas simulação — nenhum dado é gravado, nenhuma marca d'água é movida.",
      "table": {
        "title": "Registros de amostra",
        "count": "Exibindo {{n}} de {{total}} obtidos",
        "empty": "Nenhum registro nesta janela.",
        "mapped": "mapeado"
      },
      "match": {
        "create": "Criar",
        "update": "Atualizar",
        "noChange": "Sem alteração"
      },
      "counts": {
        "user": "{{n}} usuários obtidos",
        "sales": "{{n}} registros obtidos (uma página)",
        "attendance": "{{n}} linhas processadas",
        "generic": "{{n}} registros obtidos",
        "salesHelp": "Uma página conforme o máximo configurado — não é o total de vendas do inquilino nem necessariamente as vendas mais recentes."
      },
      "plan": {
        "title": "Plano de sincronização",
        "population": "{{wstudioUsers}} usuários do WStudio · {{ghlContacts}} contatos do GoHighLevel",
        "create": "{{n}} seriam criados",
        "update": "{{n}} seriam atualizados",
        "noChange": "{{n}} já atualizados",
        "unmatched": "{{n}} contatos sem correspondência no WStudio",
        "unmatchedHelp": "Eles não são alterados — a sincronização nunca desativa nem remove contatos.",
        "lastPurchaseFootnote": "Alterações de última compra não são verificadas, portanto o número de atualizações é um mínimo.",
        "cappedWarning": "A extração de usuários do WStudio foi limitada — estes números cobrem apenas parte da população.",
        "allCreateWarning": "O GoHighLevel tem {{ghlContacts}} contatos, mas todos os {{wstudioUsers}} usuários do WStudio seriam criados em vez de correspondidos. O mapeamento contact.wstudio_id aponta para o campo errado do GoHighLevel e uma sincronização real duplicaria todos os contatos. Verifique o mapeamento antes de ativar a sincronização."
      },
      "requestUrl": {
        "label": "Requisição ao WStudio"
      },
      "attendance": {
        "title": "Análise do relatório",
        "rowsInSheet": "{{n}} linhas no relatório",
        "parsed": "{{n}} processadas",
        "openGym": "{{n}} linhas de ginásio livre ignoradas",
        "incomplete": "{{n}} linhas incompletas ignoradas",
        "emptyReport": "O relatório foi gerado com sucesso, mas não continha linhas para esta janela.",
        "incompleteWarning": "{{n}} de {{total}} linhas chegaram sem data, hora ou membro. Isso normalmente significa que o layout de colunas do relatório de presença mudou — verifique o relatório antes de confiar nesta sincronização."
      },
      "ghlFields": {
        "checked": "{{n}} mapeamentos verificados",
        "present": "{{n}} presentes",
        "missing": "{{n}} ausentes no GoHighLevel",
        "unresolved": "{{n}} nunca resolvidos",
        "matchKeyBroken": "contact.wstudio_id — o campo que associa usuários do WStudio a contatos do GoHighLevel — está {{outcome}}. Até ser corrigido, uma sincronização real não encontraria correspondências e criaria um contato duplicado para cada usuário em cada execução.",
        "repairHelp": "Os campos ausentes devem ser criados ou renomeados no GoHighLevel e, em seguida, execute este teste novamente. O console não pode criá-los."
      }
    },
    "syncWindow": {
      "title": "Estado da janela de sincronização",
      "syncWindow": "janela de sincronização",
      "inBackfill": "Em preenchimento",
      "steadyState": "Estado estável",
      "progress": "Progresso do preenchimento",
      "cursor": "Cursor",
      "lastWindow": "Última janela",
      "never": "—",
      "loadError": "Não foi possível carregar o estado da janela de sincronização."
    },
    "jobs": {
      "title": "Trabalhos de ingestão · este inquilino",
      "tableAriaLabel": "Trabalhos de ingestão para este inquilino",
      "loadError": "Não foi possível carregar o histórico de trabalhos."
    },
    "identity": {
      "loadError": "Não foi possível carregar a identidade do inquilino.",
      "opsNotProvisioned": "As configurações operacionais deste inquilino ainda não estão disponíveis — o wsr-api ainda não o espelhou. Ele aparecerá na próxima sincronização.",
      "status": {
        "ACTIVE": "Ativo",
        "INACTIVE": "Inativo",
        "SUSPENDED": "Suspenso"
      }
    },
    "members": {
      "title": "Equipe",
      "help": "Quem pode entrar no wsr-admin deste inquilino.",
      "tableAriaLabel": "Equipe do inquilino",
      "col": {
        "email": "E-mail",
        "name": "Nome",
        "role": "Função",
        "status": "Status",
        "actions": "Ações"
      },
      "role": {
        "OWNER": "Proprietário",
        "SUPER_ADMIN": "Super Admin",
        "ADMIN": "Admin",
        "STAFF": "Equipe",
        "USER": "Usuário",
        "GUEST": "Convidado"
      },
      "status": {
        "ACTIVE": "Ativo",
        "INVITED": "Convidado",
        "DISABLED": "Desabilitado"
      },
      "loadError": "Não foi possível carregar a equipe.",
      "empty": "Ainda não há equipe.",
      "changeRoleLabel": "Função para {{email}}",
      "changeRoleError": "Não foi possível alterar a função. Tente novamente.",
      "disableLabel": "Habilitado",
      "toggleStatusError": "Não foi possível atualizar o status da equipe. Tente novamente.",
      "removeButton": "Remover",
      "removeConfirmTitle": "Remover equipe?",
      "removeConfirmBody": "Isso remove {{email}} da equipe wsr-admin deste inquilino. A conta não é excluída.",
      "removeError": "Não foi possível remover a equipe. Tente novamente.",
      "lastOwnerProtected": "Isso removeria o último proprietário do inquilino.",
      "roleChangeCrossesTables": "Esta alteração de função não é permitida para este membro da equipe.",
      "addTitle": "Adicionar equipe",
      "addEmailLabel": "E-mail",
      "addEmailRequired": "O e-mail é obrigatório.",
      "addRoleLabel": "Função",
      "addButton": "Adicionar",
      "addSuccessMember": "Equipe adicionada.",
      "addSuccessInvitation": "Convite enviado.",
      "addErrorAlreadyActive": "Essa pessoa já é um membro ativo da equipe.",
      "addErrorAlreadyPending": "Já há um convite pendente para este e-mail.",
      "addError": "Não foi possível adicionar a equipe. Tente novamente."
    },
    "invitations": {
      "title": "Convites",
      "tableAriaLabel": "Convites do inquilino",
      "col": {
        "email": "E-mail",
        "role": "Função",
        "status": "Status",
        "created": "Criado",
        "expires": "Expira",
        "actions": "Ações"
      },
      "statusAll": "Mostrar todos",
      "status": {
        "PENDING": "Pendente",
        "ACCEPTED": "Aceito",
        "REVOKED": "Revogado",
        "EXPIRED": "Expirado"
      },
      "loadError": "Não foi possível carregar os convites.",
      "empty": "Nenhum convite pendente.",
      "emptyAll": "Nenhum convite.",
      "resendButton": "Reenviar",
      "resendError": "Não foi possível reenviar o convite. Tente novamente.",
      "revokeButton": "Revogar",
      "revokeConfirmTitle": "Revogar convite?",
      "revokeConfirmBody": "Isso revoga o convite pendente para {{email}}. Ele não poderá mais aceitá-lo.",
      "revokeError": "Não foi possível revogar o convite. Tente novamente.",
      "alreadyAccepted": "Este convite já foi aceito. A lista foi atualizada.",
      "notFound": "Este convite não foi encontrado. A lista foi atualizada."
    }
  },
  "tenantQueue": {
    "title": "Fila",
    "empty": "Nada em execução ou agendado."
  },
  "warehouse": {
    "title": "Armazém",
    "members": "Membros do WStudio",
    "sales": "Vendas",
    "attendance": "Presenças",
    "products": "Produtos",
    "syncedAgo": "sincronizado há {{duration}}",
    "fullHistory": "histórico completo",
    "backTo": "até {{date}}"
  },
  "activity": {
    "title": "Atividade",
    "ranAgo": "há {{duration}}",
    "col": {
      "job": "Trabalho",
      "kind": "Tipo",
      "records": "Registros",
      "ran": "Executado",
      "next": "Próximo"
    },
    "caughtUp": "Em dia",
    "counters": {
      "fetched": "{{n}} obtidos",
      "landed": "{{n}} carregados",
      "updated": "{{n}} atualizados",
      "unchanged": "{{n}} inalterados",
      "failed": "{{n}} com falha",
      "ghlUpdates": "{{n}} atualizações do GHL",
      "ghlInserts": "{{n}} inserções do GHL",
      "ghlFailures": "{{n}} falhas do GHL",
      "ghlContactsRetrieved": "{{n}} contatos GHL recuperados",
      "labelRows": "{{n}} linhas de rótulo",
      "categoryRows": "{{n}} linhas de categoria",
      "detailLines": "{{n}} linhas de detalhe",
      "duplicatesCollapsed": "{{n}} duplicatas agrupadas",
      "rowsInSheet": "{{n}} linhas na planilha"
    },
    "kind": {
      "GENESIS": "gênese",
      "BACKFILL": "histórico",
      "LEADING_EDGE": "borda atual",
      "INCREMENTAL": "incremental"
    },
    "next": {
      "in": "em {{duration}}",
      "off": "desativado"
    }
  },
  "syncHistory": {
    "title": "Histórico de sincronização",
    "emptyJobs": "Nenhuma execução de sincronização nos últimos 14 dias.",
    "emptyJournalUserSync": "Nenhuma alteração por usuário nesta execução.",
    "emptyJournalOtherType": "Este tipo de trabalho não tem diário por linha. O resultado e as contagens estão no cabeçalho da execução.",
    "emptyJournalUnknown": "Nenhum diário por linha para esta execução.",
    "jobNotFound": "Esta execução não é mais retida.",
    "backToList": "Voltar à lista",
    "loadError": "Não foi possível carregar o histórico de sincronização.",
    "journalTitle": "Diário",
    "jobTitle": "Trabalho {{id}}",
    "filters": {
      "statusAria": "Filtrar por status",
      "allStatuses": "Todos os status",
      "typeLabel": "Tipo de trabalho",
      "allTypes": "Todos os tipos",
      "severityLabel": "Gravidade",
      "allSeverities": "Todas as gravidades"
    },
    "col": {
      "id": "Id",
      "job": "Trabalho",
      "status": "Status",
      "kind": "Tipo",
      "finished": "Concluído",
      "records": "Registros",
      "when": "Quando",
      "severity": "Grav.",
      "action": "Ação",
      "entity": "Entidade",
      "summary": "Resumo"
    },
    "action": {
      "CREATED": "CRIADO",
      "UPDATED": "ATUALIZADO",
      "TAGGED": "MARCADO",
      "FAILED": "FALHOU"
    },
    "entity": {
      "USER": "Usuário",
      "GHL_CONTACT": "Contato do GoHighLevel"
    },
    "facts": {
      "show": "Mostrar detalhes",
      "hide": "Ocultar detalhes"
    },
    "prevPage": "Página anterior",
    "nextPage": "Página seguinte",
    "pageIndicator": "Página {{page}} de {{total}}"
  },
  "genesis": {
    "complete": "Concluído",
    "loading": "Carregando histórico",
    "notStarted": "Não iniciado",
    "coveredFrom": "até {{date}}",
    "coverageDays": "{{n}} dias cobertos",
    "windowsRemaining": "{{n}} janelas restantes"
  },
  "readiness": {
    "notConfigured": "O WStudio ainda não está configurado para este inquilino.",
    "notVerified": "Execute os testes de simulação do WStudio para verificar esta configuração. Se a configuração mudou recentemente, execute-os novamente.",
    "readyToStart": "Verificado e pronto. Ative este inquilino para começar a carregar seu histórico.",
    "blockedGlobal": "A ingestão está desativada em toda a plataforma. Ative-a em Inquilinos → Ativar a ingestão global.",
    "blockedTenant": "Verificado e pronto. Ative este inquilino para começar a carregar seu histórico.",
    "blockedServices": "Verificado e pronto, mas estes serviços estão desativados: {{services}}.",
    "genesisSales": "Carregando o histórico de vendas. Isso se resolve sozinho — nenhuma ação necessária.",
    "genesisAttendance": "Carregando o histórico de presença. Isso se resolve sozinho — nenhuma ação necessária.",
    "syncing": "Sincronizando com o GoHighLevel. O histórico de presença mais antigo ainda está carregando, portanto os sinais de engajamento ainda não estão disponíveis — isso é normal."
  },
  "phase": {
    "notConfigured": "Não configurado",
    "notVerified": "Não verificado",
    "readyToStart": "Pronto para iniciar",
    "genesisSales": "Carregando vendas",
    "genesisAttendance": "Carregando presenças",
    "syncing": "Sincronizando",
    "complete": "Concluído"
  },
  "emailIdentity": {
    "title": "Identidade de e-mail",
    "fromName": "Nome do remetente",
    "fromAddress": "Endereço do remetente",
    "supportEmail": "Endereço de suporte",
    "managedElsewhere": "Configurado fora deste console."
  },
  "reset": {
    "title": "Redefinir dados do WStudio",
    "description": "Exclui permanentemente tudo o que este inquilino baixou do WStudio. Não pode ser desfeito.",
    "button": "Redefinir dados",
    "blocked": {
      "tenantEnabled": "Desative este inquilino antes de redefini-lo.",
      "jobsInFlight": "Aguarde a conclusão dos trabalhos em execução e tente novamente."
    },
    "willDelete": "Isto excluirá permanentemente:",
    "showAllTables": "Mostrar todas as tabelas",
    "kept": "Mantidos: o inquilino, sua programação e interruptores, os destinatários de relatórios e o histórico de auditoria.",
    "ghlNote": "O GoHighLevel não é afetado. Contatos, campos personalizados e tags desses membros permanecem no GoHighLevel e devem ser removidos lá.",
    "alsoDeleteConfig": "Limpar também as configurações de conexão do WStudio",
    "alsoDeleteConfigHelp": "Será necessário inserir novamente o domínio, o token e o Studio ID antes que este inquilino possa sincronizar.",
    "confirmLabel": "Digite {{slug}} para confirmar",
    "confirmButton": "Excluir permanentemente",
    "successTitle": "Redefinição concluída",
    "successNextSteps": "Este inquilino agora não está verificado e nada será executado. Execute os testes de simulação e ative-o para carregar o histórico novamente.",
    "confirmMismatch": "O nome do inquilino não corresponde.",
    "nothingDeleted": "Nada foi excluído."
  },
  "bootstrap": {
    "error": "Não foi possível carregar a configuração do aplicativo.",
    "errorNotRegistered": "Este host não está registrado. Entre em contato com o administrador.",
    "retry": "Tentar novamente"
  },
  "errors": {
    "generic": "Algo deu errado. Por favor, tente novamente.",
    "network": "Erro de rede. Verifique sua conexão e tente novamente.",
    "codes": {
      "SESSION_EXPIRED": "Sua sessão expirou. Entre novamente.",
      "NETWORK_ERROR": "Erro de rede. Verifique sua conexão e tente novamente.",
      "UNKNOWN": "Algo deu errado."
    }
  }
}
